module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 14\"><g fill=\"none\" fill-rule=\"evenodd\"><rect width=\"10\" height=\"8\" x=\".5\" y=\"5.5\" stroke=\"#A2B0D5\" rx=\"2\"/><path stroke=\"#A2B0D5\" d=\"M2.5 4.5h6V3A2.5 2.5 0 0 0 6 .5H5A2.5 2.5 0 0 0 2.5 3v1.5z\"/><circle cx=\"5.5\" cy=\"8.5\" r=\"1.5\" fill=\"#A2B0D5\"/><path fill=\"#A2B0D5\" d=\"M5 8h1v3.5a.5.5 0 1 1-1 0V8z\"/></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./public/img/lock.svg
// module id = WXky
// module chunks = 5